export enum InboxView {
  MESSAGES,
  BIKE_APPROVAL,
}
